import { Component, inject, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { filter, take } from 'rxjs/operators';
import { HealthCheckService } from './shared/service/health-check.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  private healthCheckService = inject(HealthCheckService);

  title = 'greentripper-client';

  items: MenuItem[] = [
    {
      label: 'Admin side',
      icon: 'pi pi-fw pi-cog',
      routerLink: '/admin',
    },
    {
      label: 'User side',
      icon: 'pi pi-fw pi-user',
      routerLink: '/user',
    },
  ];

  ngOnInit(): void {
    this.healthCheckService.checkBackend();
    this.hideLoaderOnReady();
  }

  private hideLoaderOnReady(): void {
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        take(1)
      )
      .subscribe(() => {
        // Clear the timeout so loader doesn't show if app loaded fast
        const win = window as unknown as { loaderTimeout?: number };
        if (win.loaderTimeout) {
          clearTimeout(win.loaderTimeout);
        }
        const loader = document.getElementById('app-loader');
        if (loader) {
          loader.classList.add('hidden');
          setTimeout(() => loader.remove(), 500);
        }
      });
  }
}
